import React from 'react';
import { Grid as MuiGrid, GridProps as MuiGridProps } from '@mui/material';

// With MUI v6, we don't need as many custom overrides
const Grid = (props: MuiGridProps) => {
  // We can pass props directly to MuiGrid with v6
  return <MuiGrid {...props} />;
};

export default Grid;